export default __webpack_public_path__ + "static/media/mainPic.9237a244.png";